module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ahip45-456b66dc9c62d6ba044bec85cb27deab.jpg";